import actions from 'modules/booking/list/bookingListActions';
import paginationReducer from 'modules/shared/pagination/paginationReducer';

export default paginationReducer(actions);
